module.exports = "/packs/media/images/icons/icon_achievable-6b91b34975f2b539484105f0b305e893.png";